import React, { useState, useRef, useEffect } from 'react';
import { Markmap } from 'markmap-view';
import { Toolbar } from 'markmap-toolbar';
import { transformer, safeTransform } from './markmap';
import 'markmap-toolbar/dist/style.css';
import { useConfig } from '../../contexts/ConfigContext'; // ✅ 添加配置导入

export const Markdown2Svg = (props) => {
  const {txt, divHeight,fileName,fullScreenDisable,setMdTxt,setFileName} = props
  const [error, setError] = useState(null);
  const { theme } = useConfig(); // ✅ 获取主题配置
  
  const renderToolbar = (mm, wrapper) => {
    try {
      if (!wrapper || !mm) return;
      
      // 清空现有内容
      while (wrapper?.firstChild) wrapper.firstChild.remove();
      
      const toolbar = new Toolbar();
      toolbar.setBrand(false);
      toolbar.attach(mm);
      toolbar.register({
        id:'fullScreen',
        title:"full screen",
        content: " 全屏",
        onClick: () =>{
          if (setFileName && fileName) {
            setFileName(fileName)
          }
          if (setMdTxt && txt) {
            setMdTxt(txt)
          }
          const modal = document.getElementById('my_fullscreen_mindtree_modal');
          if (modal) {
            modal.showModal();
          }
        }
      });
      toolbar.register({
        id:'download',
        title:"download",
        content: " 下载",
        onClick: () =>{
          if (refSvg.current) {
            downloadSvg(refSvg.current)
          }
        }
      })

      toolbar.setItems([...['zoomIn', 'zoomOut', 'fit', 'download'], ... fullScreenDisable ? [] : ['fullScreen']]);
      wrapper.append(toolbar.render());
    } catch (err) {
      console.error('Toolbar rendering error:', err);
      setError(err.message);
    }
  };

  const refSvg = useRef();
  const refMm = useRef();
  const refToolbar = useRef();

  useEffect(() => {
    // Create markmap and toolbar
    try {
      if (!refSvg.current) return;
      // 只设置一次
      if (!refSvg.current.getAttribute('width') || !refSvg.current.getAttribute('height')) {
        const rect = refSvg.current.getBoundingClientRect();
        if (rect.width && rect.height) {
          refSvg.current.setAttribute('width', rect.width);
          refSvg.current.setAttribute('height', rect.height);
        }
      }
      
      if (refMm.current) return;
      // ✅ 创建 markmap 时应用主题色配置
      const mm = Markmap.create(refSvg.current, {
        // 设置颜色方案
        color: (d) => theme.primary, // 统一使用主题色
        // 或者使用渐变色
        colorFreezeLevel: 6,
        // 自定义颜色数组
        colorScheme: [
          theme.primary,
          theme.primaryHover,
          `${theme.primary}CC`,
          `${theme.primary}99`,
          `${theme.primary}66`,
          `${theme.primary}33`
        ]
      });
      
      refMm.current = mm;
      
      if (refToolbar.current) {
        renderToolbar(refMm.current, refToolbar.current);
      }
    } catch (err) {
      console.error('Markmap initialization error:', err);
      setError(err.message);
    }
  }, [refSvg.current, theme]); // ✅ 添加 theme 依赖

  useEffect(() => {
    // Update data for markmap once value is changed
    try {
      const mm = refMm.current;
      if (!mm || !txt) return;
      
      const { root } = safeTransform(txt?.replace(/```/g,''));
      if (root) {
        mm.setData(root);
        mm.fit();
      }
    } catch (err) {
      console.error('Markmap data update error:', err);
      setError(err.message);
    }
  }, [refMm.current, txt]);

  // ✅ 添加全局样式来强制覆盖 markmap 的默认颜色
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      /* 强制覆盖 markmap 的颜色 */
      .markmap-container .markmap-link {
        stroke: ${theme.primary} !important;
        stroke-width: 2px !important;
        opacity: 0.8 !important;
      }
      
      .markmap-container .markmap-node > circle {
        fill: ${theme.primary} !important;
        stroke: ${theme.primary} !important;
        stroke-width: 2px !important;
      }
      
      .markmap-container .markmap-node > rect {
        fill: ${theme.primary} !important;
        stroke: ${theme.primary} !important;
        stroke-width: 1px !important;
      }
      
      .markmap-container .markmap-node text {
        fill: ${theme.text} !important;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
      }
      
      /* 悬停效果 */
      .markmap-container .markmap-node:hover > circle {
        fill: ${theme.primaryHover} !important;
        stroke: ${theme.primaryHover} !important;
      }
      
      .markmap-container .markmap-node:hover > rect {
        fill: ${theme.primaryHover} !important;
        stroke: ${theme.primaryHover} !important;
      }
      
      /* 强制所有层级使用相同颜色 */
      .markmap-container g[data-depth] .markmap-node > circle,
      .markmap-container g[data-depth] .markmap-node > rect {
        fill: ${theme.primary} !important;
        stroke: ${theme.primary} !important;
      }
      
      .markmap-container g[data-depth] .markmap-link {
        stroke: ${theme.primary} !important;
      }
    `;
    
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, [theme]);

  const downloadSvg = (svgElement) => {
    try {
      if (!svgElement) return;
      
      const serializer = new XMLSerializer();
      const source = serializer.serializeToString(svgElement);
      const blob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = `政策脉络.svg`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (err) {
      console.error('Download error:', err);
    }
  };

  return (
    <div className="markmap-container" style={{ height: divHeight || '400px', display: 'flex', flexDirection: 'column' }}>
      {error && (
        <div className="alert alert-error mb-4">
          <span>渲染错误: {error}</span>
        </div>
      )}
      
      
      <>
      <svg 
        ref={refSvg} 
        style={{ 
          width: '100%', 
          height: '100%',
          // ✅ 设置 CSS 变量
          '--markmap-color-1': theme.primary,
          '--markmap-color-2': theme.primary,
          '--markmap-color-3': theme.primary,
          '--markmap-color-4': theme.primary,
          '--markmap-color-5': theme.primary,
          '--markmap-color-6': theme.primary,
        }} 
      />
       <div className="absolute bottom-1 right-1" ref={refToolbar}></div>

      </>
    </div>
  );
}